module.exports = __webpack_public_path__ + "img/verified-seller.4162d6ab.png";